// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Unoccupied';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B12/11000003',
  policyDetailsId: '110000031001',
  coverType: 'Buildings',
  isUnoccupied: true,
  hasUnoccupiedExtendedPerils: false
});
